import React, { useState } from "react";
import { FaDesktop, FaMapMarkedAlt, FaMobileAlt } from "react-icons/fa";

const Territories = () => {
  const [activeTab2, setActiveTab2] = useState("web");
  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];
  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${
            activeState === tab.id
              ? "bg-[#1a9588] text-white shadow-md"
              : "bg-[#dbf4f1] text-gray-600 hover:bg-[#b9ece6] bg-gray-700 hover:bg-gray-600"
          } ${tab.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );
  return (
    <div>
      <div className="flex items-center gap-4 mb-8">
        <FaMapMarkedAlt className="text-pink-600 text-5xl" />
        <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">
          Territories
        </h1>
      </div>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 gap-4">
        <div className="flex flex-wrap gap-2">
          <span className="bg-pink-600 text-white px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
            Seller
          </span>
          <span className="bg-yellow-100 text-yellow-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
            Buyer
          </span>
        </div>
        <div className="flex flex-wrap gap-2">
          <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
            Web
          </span>

          <span className="bg-green-100 text-green-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
            Android
          </span>
        </div>
      </div>
      <p className="text-start mb-6 text-gray-600 text-gray-300">
        Territories serve as a bridge between your Sales Reps and Buyers. They
        also allow you to analyze and view your orders segmented by geographical
        regions.
      </p>
      {/* <div className="text-start">
                <h3 className="text-2xl text-gray-500 mb-2">Adding / Updating Products</h3>
                <p className="text-gray-600 mb-6">
                    Go to the 'Products' section & click on 'Add New'. Fill in the fields and click 'Save'. The new product is saved to the database.
                </p>
            </div> */}

      <div>
        <div className="text-start">
          <h3 className="text-2xl text-gray-500 mb-2">
            Add / Update Territory
          </h3>
          <p className="text-gray-600 mb-6">
            Territories can be managed in the 'Settings' section. To create a
            new territory, click 'Add New' and enter the territory name.
          </p>
        </div>
        {renderTabs(activeTab2, setActiveTab2)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src=""
            alt={`${activeTab2} view`}
            className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </div>

      <div className="bg-red-100 text-red-800 p-4 rounded-lg border border-red-300 text-start">
        Territory once defined cannot be deleted.
      </div>

      <div className="my-4">
        {renderTabs(activeTab2, setActiveTab2)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src=""
            alt={`${activeTab2} view`}
            className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </div>

      <div>
        <div className="text-start">
          <h3 className="text-2xl text-gray-500 mb-2">Territory & Buyers</h3>
          <p className="text-gray-600 mb-6">
            When you approve a Buyer’s request to place orders, you can assign
            them to a specific territory. This links the buyer to all Sales Reps
            operating in that region. Once linked, your Sales Reps are notified
            whenever the buyer places or cancels an order.
          </p>
        </div>
        {renderTabs(activeTab2, setActiveTab2)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src=""
            alt={`${activeTab2} view`}
            className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </div>

      <div>
        <div className="text-start">
          <h3 className="text-2xl text-gray-500 mb-2">
            Territory & Sales Reps
          </h3>
          <p className="text-gray-600 mb-6">
            When adding a new user as a Sales Rep, you can assign the
            territories they will manage. This links the Sales Rep to all buyers
            within those territories. Once linked, the Sales Rep will receive
            notifications whenever any buyer in their assigned territories
            places or cancels an order.
          </p>
        </div>
        {renderTabs(activeTab2, setActiveTab2)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src=""
            alt={`${activeTab2} view`}
            className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </div>

      <div className="bg-yellow-100 text-yellow-800 p-4 rounded-lg border border-yellow-300 text-start my-4">
        Use the toggle to show or hide a warehouse for all products. The changes
        will only be applied after you publish your product data.
      </div>
    </div>
  );
};

export default Territories;
